import './RemoteConnectModal.scss'
import { ReactFlow, Background } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import CustomNode from './CustomNode';
import useHwil from '../../../../hooks/useHwil';
import { useMemo } from 'react';

const RemoteConnectModal = () => {
    const { allRemoteApplications, remoteConnectionModal } = useHwil();
    const nodes = useMemo(() => allRemoteApplications.nodes, [allRemoteApplications.nodes]);
    const edges = useMemo(() => allRemoteApplications.edges, [allRemoteApplications.edges]);

    const nodeTypes = {
        custom: CustomNode,
    };
    const defaultViewport = useMemo(() => ({ x: 400, y: 10, zoom: 0.7 }), [remoteConnectionModal]);

    return (
        <div className={`remote__connect__modal__container ${remoteConnectionModal ? 'open' : ''}`}>
            <div className='remote__connect__modal'>
                <ReactFlow
                    key={remoteConnectionModal ? 'open' : 'closed'}
                    nodes={nodes}
                    edges={edges}
                    colorMode='dark'
                    nodeTypes={nodeTypes}
                    minZoom={0.5}
                    maxZoom={1}
                    defaultViewport={defaultViewport}
                    fitViewOptions={{
                        padding: 0.1,
                        includeHiddenNodes: false,
                        minZoom: 0.1,
                        maxZoom: 1,
                        duration: 200,
                        nodes: nodes, // nodes to fit
                    }}
                >
                    <Background />
                </ReactFlow>
            </div>
        </div>
    )
}

export default RemoteConnectModal